/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';
import { bookTitleData } from './GetBookTitlesDataModel';

/** Graph list for the Observe / Feedback Graph ID field; kept apart from bookTitles so both lists can load together. */
const GetAuditGraphTitlesDataModel = types
  .model('GetAuditGraphTitlesDataModel', {
    data: types.optional(types.array(bookTitleData), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.FETCH_AUDIT_GRAPH_TITLES_DATA, {
        payload
      });
    },
    setResponse(response) {
      const body = response?.data;
      let list = [];
      if (Array.isArray(body)) {
        list = body;
      } else if (Array.isArray(body?.data)) {
        list = body.data;
      }
      applySnapshot(self, { data: list });
      Framework.getEventManager().publish(constants.SET_AUDIT_GRAPH_TITLES_DATA);
    },
    resetStoreValues() {
      applySnapshot(self.data, []);
      Framework.getEventManager().publish(constants.SET_AUDIT_GRAPH_TITLES_DATA);
    }
  }));

export default GetAuditGraphTitlesDataModel;
